import { Box, Stack, Typography } from "@mui/material";
import type { ReactNode } from "react";

import { DashViewAllButton } from "./DashViewAllButton";

interface DashMobileSectionHeaderProps {
  title: string;
  subtitle?: string;
  onViewAll?: () => void;
  viewAllLabel?: string;
  action?: ReactNode;
}

/**
 * Cabeçalho padrão das seções do dashboard mobile (título + ação / Ver tudo).
 */
export function DashMobileSectionHeader({
  title,
  subtitle,
  onViewAll,
  viewAllLabel = "Ver tudo",
  action,
}: DashMobileSectionHeaderProps) {
  return (
    <Stack
      direction="row"
      alignItems="flex-start"
      justifyContent="space-between"
      spacing={1.25}
      sx={{ mb: 1.25 }}
    >
      <Box sx={{ minWidth: 0, flex: 1 }}>
        <Typography
          variant="subtitle1"
          fontWeight={700}
          sx={{
            fontSize: "0.9375rem",
            lineHeight: 1.25,
            color: "text.primary",
            letterSpacing: "-0.01em",
          }}
        >
          {title}
        </Typography>
        {subtitle ? (
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{
              display: "block",
              mt: 0.35,
              lineHeight: 1.35,
              fontSize: "0.6875rem",
              opacity: 0.9,
            }}
          >
            {subtitle}
          </Typography>
        ) : null}
      </Box>

      {action ??
        (onViewAll ? (
          <DashViewAllButton
            variant="inline"
            label={viewAllLabel}
            onClick={onViewAll}
          />
        ) : null)}
    </Stack>
  );
}
